export default __webpack_public_path__ + "static/media/25120407.874cf6e8.png";